import { Lifecycle } from '../models/lifecycles.model';

/**
 * IVL B-phase reference study period (years). Used by B1.2, B2, and B7 rules.
 * Hardcoded at 50 years regardless of the user-set building lifetime (DEV-3319).
 */
export const IVL_B_PHASE_REFERENCE_PERIOD_YEARS = 50;

export const lifecycleDescriptions: Record<Lifecycle, string> = {
  [Lifecycle.A1A3]: 'Product Stage',
  [Lifecycle.A4]: 'Transport to Site',
  [Lifecycle.A5]: 'Construction/Installation',
  // EN 15804+A2: B1 — use or application of the installed product (building fabric)
  [Lifecycle.B1]: 'Use of installed products',
  [Lifecycle.B2]: 'Maintenance',
  [Lifecycle.B4]: 'Replacement',
  [Lifecycle.B6]: 'Operational Energy Use',
  [Lifecycle.B7]: 'Operational Water Use',
  [Lifecycle.C1]: 'Deconstruction/Demolition',
  [Lifecycle.C2]: 'Transport to Waste Processing',
  [Lifecycle.C3C4]: 'Waste Processing and Disposal',
};

/**
 * Get the description for a lifecycle stage
 * @param lifecycle - The lifecycle stage to get the description for
 * @returns The description of the lifecycle stage
 */
export const getLifecycleDescription = (lifecycle: Lifecycle): string => {
  return lifecycleDescriptions[lifecycle];
};
